import {
  AddToCartEventContent,
  AddToWishlistEventContent,
  ProductViewedEventContent,
} from 'generatedBfw/static/index';

type AddToCartFacebookData = {
  value: string;
  currency: string;
  content_ids: number;
  author: string;
  title: string;
};

type ViewContentFacebookData = {
  content_ids: number;
  content_type: string;
};

// to extend with future usage
type facebookData =
  | AddToCartFacebookData
  | ViewContentFacebookData
  | AddToCartEventContent
  | ProductViewedEventContent
  | AddToWishlistEventContent;

export const createFacebookTrackingEvent = (
  eventName: string,
  eventContent: facebookData,
  eventId = '',
) => {
  const { fbq = undefined } = window;
  fbq?.('track', eventName, eventContent, { eventId: eventId });
};
